import { SiteListingPaginationProps } from "pages/Site/pages/type";
import React, { useEffect, useState } from "react";
import { Pagination } from "shared";

const SiteListingPagination = ({
  onChange,
  totalPage,
}: SiteListingPaginationProps) => {
  if (totalPage == 0) return null
  return <Pagination totalPage={totalPage} onChange={onChange} />;
};

export default SiteListingPagination;
